import DebugSidebarRender from './DebugSidebarRender';
export default DebugSidebarRender;
//# sourceMappingURL=index.js.map